import { createSlice } from '@reduxjs/toolkit';

export interface AclState {
  loading: boolean;
  isLoaded: boolean;
  tree: object;
}

const initialState: AclState = {
  loading: false,
  isLoaded: false,
  tree: {}
};

export const aclSlice = createSlice({
  name: 'acl',
  initialState,
  reducers: {
    setAclLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setAclTree: (state, {payload}) => {
      state.tree = payload;
      state.isLoaded = true;
      state.loading = false;
    },
    setAclLoaded: (state, { payload }) => {
      state.isLoaded = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAclLoading, setAclTree, setAclLoaded } = aclSlice.actions;
export const selectAclIsLoading = (state: any) => state.acl.loading;
export const selectAclIsLoaded = (state: any) => state.acl.isLoaded;
export const selectAclTree = (state: any) => state.acl.tree;

export default aclSlice.reducer;
